import React from 'react';
import styles from './ProgressBar.module.css';
import cn from 'classnames';

type ProgressBarProps = {
    /**
     * Progress in range of 0-100
     */
    progress: number;
    trackStyles?: React.CSSProperties;
    barStyles?: React.CSSProperties;
};

const ProgressBar = ({ progress, trackStyles, barStyles }: ProgressBarProps) => {
    return (
        <div className={cn(styles.track)} style={trackStyles}>
            <div className={styles.bar} style={{ width: `${progress}%`, ...barStyles }} />
        </div>
    );
};

export default ProgressBar;
